import { NOTIFICATION_TYPES } from '@vbee-holding/aivoice-shared-lib';

const NOTIFICATION_TABS = [
  { key: NOTIFICATION_TYPES.PROMOTION, labelKey: 'notificationPromotion' },
  { key: NOTIFICATION_TYPES.NEWS, labelKey: 'notificationNews' },
  { key: NOTIFICATION_TYPES.SYSTEM, labelKey: 'notificationSystem' },
];

const NOTIFICATION_PAGE_SIZE = 20;

export { NOTIFICATION_TABS, NOTIFICATION_PAGE_SIZE };
